//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PIDataModelModal from "@/components/Admin/ProcessInspector/PIDataModelModal.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import { convertAndFormatTimeToLocal, eventBus } from "@/assets/js/appFunc";
import { APP_DATE_DOT_FORMAT } from "@/assets/js/appConfig";
import { mapGetters, mapActions } from "vuex";
import editor from "vue2-ace-editor";
/* eslint-disable import/no-extraneous-dependencies */
import "brace/mode/javascript";
import "brace/mode/text";
import "brace/mode/json";
import "brace/theme/tomorrow";

export default {
    components: {
        editor,
        AQTooltip,
        PIDataModelModal,
        AQButton,
        AQMenu,
        AQDialog
    },
    props: {
        instanceID: {
            type: String,
            default: ""
        },
        instanceName: {
            type: String,
            default: ""
        },
        systemStatus: {
            type: String,
            default: ""
        },
        stackTrace: {
            type: null,
            default: ""
        },
        isChildSync: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            APP_DATE_DOT_FORMAT,
            addDataModelModal: false,
            lastUpdateDateTime: "",
            lastUpdateUsername: "",
            dataModelData: {},
            dataModelClassIds: [],
            dataModelJsonView: "",
            showMenu: [],

            openDialog: false,
            audit: false,
            personalInf: false
        };
    },
    computed: {
        ...mapGetters("admin", ["getProcessInspectorById"]),
        menuOptions() {
            return [
                {
                    label: this.$t("admin.processInspector.deleteValues"),
                    itemDisabled: this.disableOption(),
                    tooltipProps: this.isChildSync
                        ? { tooltipContent: this.$t("admin.processInspector.deleteDataModelDisabledTooltip"), direction: "left" }
                        : null
                },
                { label: this.$t("admin.processInspector.deleteAuditData"),
                    itemDisabled: this.disableOption(),
                    tooltipProps: this.isChildSync
                        ? { tooltipContent: this.$t("admin.processInspector.deleteAllDataModelDisabledTooltip"), direction: "left" }
                        : null },
                { label: this.$t("admin.processInspector.deletePersonalInfo"),
                    itemDisabled: this.disableOption(),
                    tooltipProps: this.isChildSync
                        ? { tooltipContent: this.$t("admin.processInspector.deleteAllDataModelDisabledTooltip"), direction: "left" }
                        : null }
            ];
        },
        dataModelEditorProps() {
            return {
                instanceID: this.instanceID,
                dataModelClassIds: this.dataModelClassIds,
                dataModelData: this.dataModelData,
                instName: this.instanceName,
                lastUpDate: this.convertAndFormatTimeToLocal(
                    this.lastUpdateDateTime,
                    this.APP_DATE_DOT_FORMAT
                ),
                lastUpUsername: this.lastUpdateUsername,
                jsonViewParsed: this.dataModelJsonView
            };
        },
        returnTitle() {
            let title = this.$t("admin.processInspector.deleteDialogTitle");
            if (this.audit) {
                title = this.$t("admin.processInspector.deleteAuditData");
            } else if (this.personalInf) {
                title = this.$t("admin.processInspector.deleteInformationTitle");
            }
            return title;
        },
        returnMessage() {
            let mess = this.$t("admin.processInspector.deleteDialog");
            if (this.audit) {
                mess = this.$t("admin.processInspector.deleteAuditDialog");
            } else if (this.personalInf) {
                mess = this.$t("admin.processInspector.deletePersonalInfoDialog");
            }
            return mess;
        }

    },
    beforeDestroy() {
        eventBus.$off("dataModelRefreshTab");
    },
    mounted() {
        this.getJson();
        eventBus.$on("dataModelRefreshTab", () => {
            this.getJson();
        });
    },
    methods: {
        convertAndFormatTimeToLocal,
        ...mapActions("admin", [
            "getDataModelInformation",
            "getProcessInspectorInformation",
            "deleteDataValues",
            "anonymizeInstance",
            "deleteDataAudit"
        ]),
        openDlg(event) {
            if (event[0].label === this.$t("admin.processInspector.deleteValues")) {
                this.openDialog = true;
            } else if (event[0].label === this.$t("admin.processInspector.deleteAuditData")) {
                this.audit = true;
                this.openDialog = true;
            } else if (event[0].label === this.$t("admin.processInspector.deletePersonalInfo")) {
                this.openDialog = true;
                this.personalInf = true;
            }
        },

        okAction() {
            if (this.audit) {
                this.deleteDataAudit(this.getProcessInspectorById.rootProcessInstanceId).then(() => {
                    this.getJson();
                    this.showNotify();
                    this.audit = false;
                    this.$emit("actionDone");
                });
            } else if (this.personalInf) {
                this.anonymizeInstance(this.getProcessInspectorById.rootProcessInstanceId).then(() => {
                    this.getJson();
                    this.showNotify();
                    this.personalInf = false;
                });
            } else {
                this.deleteDataValues(this.getProcessInspectorById.rootProcessInstanceId).then(() => {
                    this.getJson();
                    this.showNotify();
                });
            }
        },
        cancelAction() {
            this.openDialog = false;
            this.audit = false;
            this.personalInf = false;
        },
        showNotify() {
            let messNotify = this.$t("admin.processInspector.deleteValuesConfirmation");
            if (this.audit) {
                messNotify = this.$t("admin.processInspector.deleteAuditConfirmation");
            } else if (this.personalInf) {
                messNotify = this.$t("admin.processInspector.deleteInformationConfirmation");
            }
            this.$toast.showNotify({
                type: "success",
                message: messNotify,
                timeout: 500
            });
        },
        editorInit(editorInstance) {
            editorInstance.setReadOnly("true");
        },
        actionDone() {
            this.$emit("actionDone");
        },
        editDataModel() {
            if (!this.isChildSync) {
                this.addDataModelModal = true;
            }
        },
        goToJsonRefresh(event) {
            if (event) {
                this.getJson();
            }
        },
        getJson() {
            const vm = this;
            const jsonObj = {};
            this.getDataModelInformation(this.instanceID).then(data => {
                this.lastUpdateDateTime = data.data.lastUpdate;
                this.lastUpdateUsername = data.data.username;
                vm.dataModelData = data.data.data || null;
                if (vm.dataModelData) {
                    for (let i = 0; i < vm.dataModelData.length; i++) {
                        const className = vm.dataModelData[i].type;
                        jsonObj[className] = JSON.parse(
                            vm.dataModelData[i].fields
                        );
                        vm.dataModelClassIds.push(vm.dataModelData[i].id);
                    }
                }

                vm.dataModelJsonView = JSON.stringify(jsonObj, null, 4);
            });
        },
        disableOption() {
            let disabledOpt = false;
            if (this.systemStatus === "RUNNING" || this.systemStatus === "FAILED" || this.isChildSync) {
                disabledOpt = true;
            }
            return disabledOpt;
        }

    }
};
